import React from 'react';
import { Query, Mutation } from '@apollo/client/react/components';

import CurrentUserQuery from 'buyside/graphql/queries/JobVaultSubmissionCurrentUser.graphql';
import CreateJobPostingMutation from 'buyside/graphql/mutations/CreateJobPosting.graphql';

import JobVaultSubmissionPage from 'buyside/components/presentation/JobVaultSubmission/JobVaultSubmissionPage';

const JobVaultSubmissionContainer = () => {
  return (
    <Query query={CurrentUserQuery}>
      {({ loading, error, data = {} }) => {
        return (
          <Mutation mutation={CreateJobPostingMutation}>
            {mutate => {
              const createJobPosting = variables => mutate({ variables });
              return (
                <JobVaultSubmissionPage
                  loading={loading}
                  error={error}
                  currentUser={data.currentUser}
                  createJobPosting={createJobPosting}
                />
              );
            }}
          </Mutation>
        );
      }}
    </Query>
  );
};

export default JobVaultSubmissionContainer;
